import Service from "../../services";

const BreedModule = {
    namespaced: true,
    state: { list: [] },
    mutations: {
        SET_ALL: (state, data) => {
            const otherElement = data.find(d => d.breed_name === 'อื่นๆ')
            const unknownElement = data.find(d => d.breed_name === 'ไม่ระบุ')
            data = data.filter(d => d.breed_name !== 'อื่นๆ' && d.breed_name !== 'ไม่ระบุ')

            if (otherElement) {
                data.push(otherElement)
            }
            if (unknownElement) {
                data.unshift(unknownElement)
            }
            state.list = data;
        }
    },
    actions: {
        setAll({ commit }) {
            Service.breed.getAllBreeds().then(res => {
                commit("SET_ALL", res);
            });
        },
    },
    getters: {
        getAll(state) {
            return state.list;
        }
    }
};
export default BreedModule;
